// MODULES
import React from "react";

// COMPONENTS
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class Collection extends React.PureComponent {

    render() {
        const { props } = this;
        const { index, fields, onOptionsListChange } = props;
        const classes = createClassName("Cob-Questionnaire-Collection", {
            "first": index === 0,
        })

        return (
            <div className={ classes }>
                <h3>FATCA</h3>

                <div className="description">
                    <p>U.S. person – Person som har ett Amerikanskt medborgarskap eller på annat sätt är skatteskyldig i USA. För mer information se blankett: Definition – FATCA</p>
                </div>

                <FieldsCollection
                    fields={[
                        {
                            render: (
                                <OptionsList
                                    type="radio"
                                    orientation="horizontal"
                                    name="radio_customer_us_person"
                                    description="Är du en så kallad U.S. person?"
                                    options={ fields.radio_customer_us_person.options }
                                    onChange={ onOptionsListChange }
                                />
                            ),
                        },
                    ]}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/odin/Fields/collections/Collection5.js